/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RewardProviderTier } from './RewardProviderTier';
import {
    RewardProviderTierFromJSON,
    RewardProviderTierFromJSONTyped,
    RewardProviderTierToJSON,
    RewardProviderTierToJSONTyped,
} from './RewardProviderTier';
import type { RewardType } from './RewardType';
import {
    RewardTypeFromJSON,
    RewardTypeFromJSONTyped,
    RewardTypeToJSON,
    RewardTypeToJSONTyped,
} from './RewardType';
import type { DurationUnit } from './DurationUnit';
import {
    DurationUnitFromJSON,
    DurationUnitFromJSONTyped,
    DurationUnitToJSON,
    DurationUnitToJSONTyped,
} from './DurationUnit';
import type { AmountUnit } from './AmountUnit';
import {
    AmountUnitFromJSON,
    AmountUnitFromJSONTyped,
    AmountUnitToJSON,
    AmountUnitToJSONTyped,
} from './AmountUnit';
import type { EmailTemplate } from './EmailTemplate';
import {
    EmailTemplateFromJSON,
    EmailTemplateFromJSONTyped,
    EmailTemplateToJSON,
    EmailTemplateToJSONTyped,
} from './EmailTemplate';

/**
 * 
 * @export
 * @interface UpdateRewardConfigRequestBody
 */
export interface UpdateRewardConfigRequestBody {
    /**
     * 
     * @type {RewardType}
     * @memberof UpdateRewardConfigRequestBody
     */
    type?: RewardType;
    /**
     * 
     * @type {string}
     * @memberof UpdateRewardConfigRequestBody
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateRewardConfigRequestBody
     */
    description?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateRewardConfigRequestBody
     */
    shouldEmailUser?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateRewardConfigRequestBody
     */
    shouldEmailAdmin?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateRewardConfigRequestBody
     */
    shouldSendNotificationWeb?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateRewardConfigRequestBody
     */
    shouldSendNotificationDevourPlay?: boolean;
    /**
     * 
     * @type {number}
     * @memberof UpdateRewardConfigRequestBody
     */
    amount?: number;
    /**
     * How many times one member may ever be granted this reward. Omit for no ceiling.
     * @type {number}
     * @memberof UpdateRewardConfigRequestBody
     */
    maxGrantsPerUser?: number;
    /**
     * How many times one member may be granted this reward within a single board period. Omit for no per-period cap.
     * @type {number}
     * @memberof UpdateRewardConfigRequestBody
     */
    maxGrantsPerPeriod?: number;
    /**
     * 
     * @type {AmountUnit}
     * @memberof UpdateRewardConfigRequestBody
     */
    amountUnit?: AmountUnit;
    /**
     * 
     * @type {number}
     * @memberof UpdateRewardConfigRequestBody
     */
    durationAmount?: number;
    /**
     * 
     * @type {DurationUnit}
     * @memberof UpdateRewardConfigRequestBody
     */
    durationUnit?: DurationUnit;
    /**
     * 
     * @type {string}
     * @memberof UpdateRewardConfigRequestBody
     */
    assetId?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateRewardConfigRequestBody
     */
    nftTrackerId?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateRewardConfigRequestBody
     */
    orderDiscountId?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateRewardConfigRequestBody
     */
    promoTokenId?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateRewardConfigRequestBody
     */
    questConfigId?: string;
    /**
     * LootBoxConfig ID granted for LOOTBOX reward type
     * @type {string}
     * @memberof UpdateRewardConfigRequestBody
     */
    lootBoxConfigId?: string;
    /**
     * 
     * @type {EmailTemplate}
     * @memberof UpdateRewardConfigRequestBody
     */
    emailTemplate?: EmailTemplate;
    /**
     * 
     * @type {string}
     * @memberof UpdateRewardConfigRequestBody
     */
    claimFormUrl?: string;
    /**
     * When true, consumers render the platform inline RewardFulfillmentClaimForm instead of opening claimFormUrl. Use for physical-ship MERCH and manually-fulfilled GIFT_CARD rewards.
     * @type {boolean}
     * @memberof UpdateRewardConfigRequestBody
     */
    useInlineFulfillmentForm?: boolean;
    /**
     * 
     * @type {number}
     * @memberof UpdateRewardConfigRequestBody
     */
    maxClaimCount?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateRewardConfigRequestBody
     */
    disclaimer?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateRewardConfigRequestBody
     */
    tilloProductId?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateRewardConfigRequestBody
     */
    tilloBrandName?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateRewardConfigRequestBody
     */
    giftCardAmount?: number;
    /**
     * 
     * @type {RewardProviderTier}
     * @memberof UpdateRewardConfigRequestBody
     */
    providerTier?: RewardProviderTier;
    /**
     * The owning brand for PARTNER-tier rewards.
     * @type {string}
     * @memberof UpdateRewardConfigRequestBody
     */
    ownerBrandId?: string;
    /**
     * Curation opt-in for self-serve pickers.
     * @type {boolean}
     * @memberof UpdateRewardConfigRequestBody
     */
    selfServeVisible?: boolean;
}



/**
 * Check if a given object implements the UpdateRewardConfigRequestBody interface.
 */
export function instanceOfUpdateRewardConfigRequestBody(value: object): value is UpdateRewardConfigRequestBody {
    return true;
}

export function UpdateRewardConfigRequestBodyFromJSON(json: any): UpdateRewardConfigRequestBody {
    return UpdateRewardConfigRequestBodyFromJSONTyped(json, false);
}

export function UpdateRewardConfigRequestBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateRewardConfigRequestBody {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'] == null ? undefined : RewardTypeFromJSON(json['type']),
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'shouldEmailUser': json['shouldEmailUser'] == null ? undefined : json['shouldEmailUser'],
        'shouldEmailAdmin': json['shouldEmailAdmin'] == null ? undefined : json['shouldEmailAdmin'],
        'shouldSendNotificationWeb': json['shouldSendNotificationWeb'] == null ? undefined : json['shouldSendNotificationWeb'],
        'shouldSendNotificationDevourPlay': json['shouldSendNotificationDevourPlay'] == null ? undefined : json['shouldSendNotificationDevourPlay'],
        'amount': json['amount'] == null ? undefined : json['amount'],
        'maxGrantsPerUser': json['maxGrantsPerUser'] == null ? undefined : json['maxGrantsPerUser'],
        'maxGrantsPerPeriod': json['maxGrantsPerPeriod'] == null ? undefined : json['maxGrantsPerPeriod'],
        'amountUnit': json['amountUnit'] == null ? undefined : AmountUnitFromJSON(json['amountUnit']),
        'durationAmount': json['durationAmount'] == null ? undefined : json['durationAmount'],
        'durationUnit': json['durationUnit'] == null ? undefined : DurationUnitFromJSON(json['durationUnit']),
        'assetId': json['assetId'] == null ? undefined : json['assetId'],
        'nftTrackerId': json['nftTrackerId'] == null ? undefined : json['nftTrackerId'],
        'orderDiscountId': json['orderDiscountId'] == null ? undefined : json['orderDiscountId'],
        'promoTokenId': json['promoTokenId'] == null ? undefined : json['promoTokenId'],
        'questConfigId': json['questConfigId'] == null ? undefined : json['questConfigId'],
        'lootBoxConfigId': json['lootBoxConfigId'] == null ? undefined : json['lootBoxConfigId'],
        'emailTemplate': json['emailTemplate'] == null ? undefined : EmailTemplateFromJSON(json['emailTemplate']),
        'claimFormUrl': json['claimFormUrl'] == null ? undefined : json['claimFormUrl'],
        'useInlineFulfillmentForm': json['useInlineFulfillmentForm'] == null ? undefined : json['useInlineFulfillmentForm'],
        'maxClaimCount': json['maxClaimCount'] == null ? undefined : json['maxClaimCount'],
        'disclaimer': json['disclaimer'] == null ? undefined : json['disclaimer'],
        'tilloProductId': json['tilloProductId'] == null ? undefined : json['tilloProductId'],
        'tilloBrandName': json['tilloBrandName'] == null ? undefined : json['tilloBrandName'],
        'giftCardAmount': json['giftCardAmount'] == null ? undefined : json['giftCardAmount'],
        'providerTier': json['providerTier'] == null ? undefined : RewardProviderTierFromJSON(json['providerTier']),
        'ownerBrandId': json['ownerBrandId'] == null ? undefined : json['ownerBrandId'],
        'selfServeVisible': json['selfServeVisible'] == null ? undefined : json['selfServeVisible'],
    };
}

export function UpdateRewardConfigRequestBodyToJSON(json: any): UpdateRewardConfigRequestBody {
    return UpdateRewardConfigRequestBodyToJSONTyped(json, false);
}

export function UpdateRewardConfigRequestBodyToJSONTyped(value?: UpdateRewardConfigRequestBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': RewardTypeToJSON(value['type']),
        'name': value['name'],
        'description': value['description'],
        'shouldEmailUser': value['shouldEmailUser'],
        'shouldEmailAdmin': value['shouldEmailAdmin'],
        'shouldSendNotificationWeb': value['shouldSendNotificationWeb'],
        'shouldSendNotificationDevourPlay': value['shouldSendNotificationDevourPlay'],
        'amount': value['amount'],
        'maxGrantsPerUser': value['maxGrantsPerUser'],
        'maxGrantsPerPeriod': value['maxGrantsPerPeriod'],
        'amountUnit': AmountUnitToJSON(value['amountUnit']),
        'durationAmount': value['durationAmount'],
        'durationUnit': DurationUnitToJSON(value['durationUnit']),
        'assetId': value['assetId'],
        'nftTrackerId': value['nftTrackerId'],
        'orderDiscountId': value['orderDiscountId'],
        'promoTokenId': value['promoTokenId'],
        'questConfigId': value['questConfigId'],
        'lootBoxConfigId': value['lootBoxConfigId'],
        'emailTemplate': EmailTemplateToJSON(value['emailTemplate']),
        'claimFormUrl': value['claimFormUrl'],
        'useInlineFulfillmentForm': value['useInlineFulfillmentForm'],
        'maxClaimCount': value['maxClaimCount'],
        'disclaimer': value['disclaimer'],
        'tilloProductId': value['tilloProductId'],
        'tilloBrandName': value['tilloBrandName'],
        'giftCardAmount': value['giftCardAmount'],
        'providerTier': RewardProviderTierToJSON(value['providerTier']),
        'ownerBrandId': value['ownerBrandId'],
        'selfServeVisible': value['selfServeVisible'],
    };
}

